// extracted by mini-css-extract-plugin
export default {"wrapper":"ButtonActive_wrapper__FqQ6z","secondaryButton":"ButtonActive_secondaryButton__Z+5lR"};